import {TLiveScoreSummary} from '../interfaces/firestore/FirestoreInterfaces';

export const showLiveScore = (liveScore?: TLiveScoreSummary) =>
  liveScore !== undefined &&
  liveScore.homeName &&
  liveScore.awayName &&
  liveScore.homeScore !== undefined &&
  liveScore.awayScore !== undefined;
